<ng-helmet>
  <title>
    Uptal ابتال | Enterprise Recruitment
  </title>
</ng-helmet>

<div class="overflow-x-hidden">

  <app-home-default></app-home-default>
  <!--<app-home-sa *ngIf="region==='sa'"></app-home-sa>-->
</div>
